import React, { Component } from 'react';
import Backend from '../../Layouts/Backend';
import { useTranslation, withTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import helper from '../../../utils/helper';
import { store } from '../../../utils/store';

const Configure = (props) => {
  const { t } = useTranslation('app');
  const [isNewDashboard, setIsNewDashboard] = React.useState(true);
  React.useEffect(() => {
    setIsNewDashboard(
      store.getState().general.currentProfile.useCustomDashboard,
    );
  }, [store.getState().general.currentProfile.useCustomDashboard]);
  return (
    <Backend>
      <div className="content-inner">
        <ConfItem
          permission="API.Department"
          path="/configure/departments"
          name="Add/Edit Department"
        />

        <ConfItem
          permission="API.GroupSetting"
          path="/configure/groups"
          name="Add/Edit Groups"
        />
        <ConfItem
          permission="API.AckPhrases"
          path="/configure/phrases"
          name="Add/Edit Phrases"
        />
        <ConfItem
          permission="AbpIdentity.Roles"
          path="/configure/roles"
          name="Add/Edit Roles"
        />
        <ConfItem
          permission="API.ScheduledReports"
          path="/configure/scheduled-reports"
          name="Add/Edit Scheduled Reports"
        />
        <ConfItem
          permission="API.Units"
          path="/configure/units"
          name="Add/Edit Units"
        />
        <ConfItem
          permission="API.Users"
          path="/configure/users"
          name="Add/Edit Users"
        />
        <ConfItem
          permission="API.AlarmIndicators"
          path="/configure/alarm-indicators"
          name="Alarm Indicator Settings"
        />
        <ConfItem
          permission="API.RemoteStations"
          path="/configure/remote-devices"
          name="Manage Remote Devices"
        />
        <ConfItem
          permission="API.SensorTypes"
          path="/configure/sensor-types"
          name="Sensor Type Settings"
        />
        {/* <ConfItem name="System Event Log" incompleted /> */}
        <ConfItem
          permission="API.Sensors.Enable"
          path="/configure/validation-control-panel"
          name="Validation Control Panel"
        />
        {/* <ConfItem name="Sensor Exchange" incompleted /> */}
        <ConfItem
          permission="API.MobileConfigurations"
          path="/configure/mobile-configurations"
          name="Mobile Configurations"
        />
        <ConfItem
          permission="API.Maps"
          path="/configure/map-management"
          name="Map Management"
        />
        <ConfItem
          permission="API.SensorCalibrations"
          path="/configure/import-calibration-swap-data"
          name="Import Calibration Swap Data"
        />
        {isNewDashboard ? (
          <ConfItem
            permission="API.Widgets"
            path="/configure/configure-custom-dashboard"
            name="Configure Custom Dashboard"
          />
        ) : null}
      </div>
    </Backend>
  );
};

const ConfItem = withTranslation('app')(function ({
  t,
  permission = 'Admin',
  path = '#',
  name,
  incompleted,
}) {
  return (
    <div>
      {helper.checkPermission(permission) && (
        <NavLink
          to={path}
          className={`configure-item ${incompleted ? 'incompleted' : ''}`}
        >
          {t(name)}
        </NavLink>
      )}
    </div>
  );
});

export default withTranslation('app')(Configure);
